import { createNamedContext } from '@utils';
import { AskAnExpertItem } from '@/types';

export const AskAnExpertContext = createNamedContext<AskAnExpertItem[]>(undefined, 'ask-an-expert');
export const AskAnExpertLoadingContext = createNamedContext<boolean>(false, 'ask-an-expert-loading');